<div class="ribbon-container {{position}}" [ngStyle]="{'top': styleTop, 'left': styleLeft, 'right': styleRight, 'height': styleHeight, 'width': styleWidth }">
    <div class="ribbon {{ribbonClass}}" [ngStyle]="{'background-color': backgroundColor}">
        <div class="arrow-ribbon {{position}}" [ngStyle]="{'border-top-color': backgroundColor}"></div>
        <span [ngStyle]="{'color': textColor, 'fontSize': fontSize}" translate>
            {{ label }}
        </span>
    </div>
</div>